import React from "react";
import {Modal, ScrollView, View} from "react-native";
import MainStyle from "../../MainStyle";
import Div from "../lib/Div";
import P from "../lib/P";
import MaterialCommunityIcons from "@expo/vector-icons/MaterialCommunityIcons";
import Btn from "../components/Btn";

type Props = {
  visible: boolean,
  isResponding: boolean,
  readinessBlockedMessage?: string | null,
  onConfirm: () => void,
  onRequestClose: () => void,
};

const ActivePlayerConfirmationModal = (props: Props) => {
  const {visible, isResponding, readinessBlockedMessage, onConfirm, onRequestClose} = props;

  // SMG-3031: no client-side auto-close. The modal's lifetime is governed by
  // the server's confirmation signal — it stays open until the player confirms
  // or an authoritative stream frame removes the pending confirmation.
  // A client timer that dismissed a still-owed confirmation would leave the
  // player with no prompt while the server-side shot gate (SMG-3031 part A)
  // still blocks them — a stuck state. The server signal is the single
  // close authority.

  // Visibility is the controller's projection of either a legacy confirmation
  // event or a bay-session turn/readiness gate.
  // The old early-return suppressed the modal on confirmationBypassEnabled —
  // which is derived from the per-SHOT on_shot setting, the WRONG signal for a
  // per-TURN modal: an autoplay-shots player (on_shot bypass) who still owes a
  // turn confirmation would have been wrongly suppressed and then blocked by
  // the server gate.

  return (
    <Modal animationType="fade" transparent visible={visible} statusBarTranslucent={false}
           hardwareAccelerated={false} onRequestClose={onRequestClose}>
      <View style={[MainStyle.fix_gradient_and_modal_error_in_landscape, MainStyle.flex1, MainStyle.bg_filter_modal]}>
        <ScrollView contentContainerStyle={MainStyle.flex1}>
          <Div minH="100%" alignItems="center" justifyContent="center">
            <Div testID="rr-confirmation-modal" bg="#131314" w={343} rounded={16}
                 overflow="hidden">
              <Div position="relative" bg="#252526" justifyContent="center">
                <P fontFamily="DavisSans-Medium" ta="center" lh={48}>You're Up Next!</P>
              </Div>

              <Div px={16} pb={16} pt={40} alignItems="center">
                <Div position="relative" mb={15}>
                  <MaterialCommunityIcons
                    name={readinessBlockedMessage ? "alert-circle" : "check-circle"} size={48}
                    color={readinessBlockedMessage ? "#FFB020" : "#1E9428"}
                  />
                  <Div position="absolute" top={10} right={10} bottom={10} left={10} bg="white" zIndex={-1}/>
                </Div>

                <P fontFamily="DavisSans-Regular" ta="center" mb={20}>
                  {readinessBlockedMessage ?? 'Tap below to start playing!'}
                </P>

                {!readinessBlockedMessage && (
                  <Btn bg="#3369FF" onPress={onConfirm} disabled={isResponding}
                       opacity={isResponding ? 0.7 : 1} w="100%">
                    <P fontFamily="DavisSans-Medium" lh={56} ta="center">Start Playing!</P>
                  </Btn>
                )}
              </Div>
            </Div>
          </Div>
        </ScrollView>
      </View>
    </Modal>
  );
};

export default ActivePlayerConfirmationModal;
